import { IRenderer, createRenderer } from 'fela';
import friendlyPseudoClass from 'fela-plugin-friendly-pseudo-class';
import placeholderPrefixer from 'fela-plugin-placeholder-prefixer';
import customProperty from './customPropertyPlugin';
import { getDefaultStylesGlobal } from './defaults.styles-global';
import namedKeysPlugin from './namedKeysPlugin';
import { webPreset } from './web-preset';

interface IProps {
  withLegacyDefaultStyles?: boolean;
}

const getFelaRenderer = ({ withLegacyDefaultStyles = true }: IProps = {}) => {
  const plugins = [
    // Important! Order of these plugins matters!
    customProperty, // Process our custom and spacing properties first, so that eg. "padding: 4" can be converted into "padding: 16px"
    ...webPreset, // Add px units to all other properties which need it, such as fontSize or width
    friendlyPseudoClass(),
    placeholderPrefixer(),
    namedKeysPlugin,
  ];

  const renderer: IRenderer = createRenderer({
    devMode: process.env.NODE_ENV !== 'production',
    optimizeCaching: true,
    selectorPrefix: 'bb-',
    plugins,
  });

  if (withLegacyDefaultStyles) {
    renderer.renderStatic(getDefaultStylesGlobal());
  }

  return renderer;
};

export default getFelaRenderer;
